import { defineStore } from 'pinia'
import { api } from '@/plugins/api'

const locationDefault = {
  firm: null,
  parent: null,
  parentName: 'OPUS IVS',
  firmName: '',
  firmId: null,
  firmNumber: null,
  firmType: null,
  isInactive: false,
  postalCode: null
}
const memberDefault = {
  locationName: '',
  locationNumber: null,
  firstname: null,
  lastname: null,
  username: null,
  password: null,
  email: null,
  addressLines: null,
  city: null,
  stateProvince: null,
  postalCode: null,
  country: null,
  roleName: 'ShopAdmin'
}

export const locationStore = defineStore('location', {
  state: () => ({
    location: JSON.parse(JSON.stringify(locationDefault)),
    locations: [],
    locationTree: [],
    members: [],
    insurers: [],
    member: null,
    addMember: JSON.parse(JSON.stringify(memberDefault)),
    parentLocation: null,
    addLocation: JSON.parse(JSON.stringify(locationDefault)),
    children: [],
    loading: {
      location: false,
      locations: false,
      advancedLocations: false,
      children: false,
      users: false,
      locationTree: false,
      findingLocations: false,
      log: false,
      members: false,
      insurers: false,
      calibrationPricing: false,
      searchShops: false,
      firmInsurance: false,
      availableInsurance: false,
      firmPartners: false,
      profileData: false,
      serviceMethodOptions: false,
      serviceListOptions: false,
      trainingCertificationOptions: false,
      savingProfile: false,
      availableInsurers: false
    },
    listParams: {
      page: 1,
      pageSize: 10,
      filterOptions: null,
      filterBy: null,
      sortBy: 'asc',
      orderBy: 'Firm',
      searchTerm: ''
    },
    foundFirm: null,
    userSearchTerm: '',
    foundFirmUsers: null,
    foundLocations: [],
    advancedLocations: [],
    foundMembers: [],
    log: [],
    isAnyMemberChecked: false,
    calibrationPricing: [],
    preferences: [],
    foundShops: [],
    newMemberCount: 0,
    postalCodes: [],
    firmInsurance: [],
    availableInsurance: [],
    firmPartners: [],
    profileData: {
      companyOverview: '',
      daysOfService: [],
      hoursOfOperation: '',
      openTime: '',
      closeTime: '',
      businessLicenseNumbers: '',
      postalCodesServiced: '',
      trainedTechnicians: 0,
      mobileVehicles: 0,
      calibrationCenters: 0,
      warranty: '',
      net30Terms: false,
      hasOtherPaymentOptions: false,
      customPaymentOptions: '',
      serviceMethods: [],
      serviceList: [],
      trainingCertificates: [],
      supportedInsurers: []
    },
    serviceMethodOptions: [],
    serviceListOptions: [],
    trainingCertificationOptions: [],
    availableInsurers: []
  }),
  actions: {
    setListParam(data) {
      this.listParams[data.name] = data.value
    },
    setLoading(data) {
      this.loading[data.name] = data.value
    },
    resetPreferences() {
      this.preferences = []
    },
    resetPostalCodes() {
      this.postalCodes = []
    },
    setPostalCode(code) {
      let found = this.postalCodes.find((x) => x === code)
      if (!found) {
        this.postalCodes.push(code)
      }
    },
    removePostalCode(code) {
      console.log('Removing Postal Code', {
        codes: this.postalCodes,
        code: code
      })
      this.postalCodes = this.postalCodes.filter((item) => item !== code)
    },
    resetLocation() {
      this.location = JSON.parse(JSON.stringify(locationDefault))
    },
    setLocation(data) {
      this.location[data.name] = data.value
    },
    setAddMember(data) {
      this.addMember[data.name] = data.value
    },
    setAddLocation(data) {
      this.addLocation[data.name] = data.value
    },
    resetAddLocation() {
      this.addLocation = JSON.parse(JSON.stringify(locationDefault))
    },
    resetFoundLocations() {
      this.foundLocations = []
    },
    resetPrices() {
      this.calibrationPricing = []
    },
    resetSearch() {
      this.foundShops = []
    },
    setUserContact(data) {
      this.location.userId = data.user
      this.userSearchTerm = null
      if (data.firstname) {
        this.userSearchTerm = `${data.lastname}, ${data.firstname}`
      } else {
        this.userSearchTerm = data.lastname
      }
    },
    setApp(data) {
      if (data) {
        let found = this.apps.find((x) => parseInt(x.app) === parseInt(data.app))
        if (found) {
          found.firm = data.firm
          found.portalUrl = data.portalUrl
          found.apiUrl = data.apiUrl
        }
      }
    },
    setOnboardLocation(data) {
      this.location = data
    },
    setUserSearchTerm(data) {
      this.userSearchTerm = data
      this.foundFirmUsers = []
    },
    resetMembersChecked() {
      this.members.items.forEach((element) => {
        element.checked = false
      })
      this.isAnyMemberChecked = false
    },
    setMember(data) {
      if (data.name === 'checked') {
        let found = this.members.items.find((x) => x.firmFirm === data.firmFirm)
        if (found) {
          found.checked = data.checked
        }
        this.isAnyMemberChecked = this.members.items.some((x) => x.checked)
      }
    },
    resetFoundMembers() {
      this.foundMembers = []
    },
    setFirmInsurance(data) {
      if (data) {
        let found = this.firmInsurance.find((x) => parseInt(x.firm) === parseInt(data.firm) && parseInt(x.firm2) === parseInt(data.firm2))
        if (found === undefined || found === null) {
          this.firmInsurance.push(data)
        }
      }
    },
    removeFirmInsurance(data) {
      if (data) {
        let found = this.firmInsurance.find((x) => parseInt(x.firm) === parseInt(data.firm) && parseInt(x.firm2) === parseInt(data.firm2))
        if (found !== undefined && found !== null) {
          this.firmInsurance = this.firmInsurance.filter((item) => item !== found)
        }
      }
    },
    processTreeFlattening(tree) {
      this.locations = []
      if (Array.isArray(tree)) {
        this.locations = this.flattenTreeArray(tree)
      } else if (tree && typeof tree === 'object') {
        this.locations = this.flattenTree(tree)
      }
      console.log('Flattened Tree', this.locations)
    },
    flattenTreeArray(treeArray) {
      return treeArray.reduce((acc, node) => {
        return acc.concat(this.flattenTree(node))
      }, [])
    },
    flattenTree(node) {
      let result = []
      if (node.name && node.id) {
        result.push({ name: node.name, id: node.id })
      }
      if (Array.isArray(node.members) && node.members.length > 0) {
        node.members.forEach((child) => {
          result = result.concat(this.flattenTree(child))
        })
      }
      return result
    },
    async getLocation(id) {
      this.resetLocation()
      this.members = []
      this.postalCodes = []
      this.loading.location = true
      this.location = await api.get(`firm/firm?firm=${id}`)
      this.loading.location = false
      if (this.location.parent) {
        this.parentLocation = JSON.parse(this.location.parent)
        this.location.parent = this.parentLocation.firm
      }
      if (this.location.postalCodes) {
        this.postalCodes = this.location.postalCodes.split(',')
      }
      this.userSearchTerm = null
      if (this.location.user) {
        let user = JSON.parse(this.location.user)
        if (user) {
          this.location.userId = user.user
          if (user.firstname) {
            this.userSearchTerm = `${user.lastname}, ${user.firstname}`
          } else {
            this.userSearchTerm = user.lastname
          }
        }
      }
      console.log('Got Location', this.location)
      return this.location
    },
    async getLocationDetails(id) {
      return await api.get(`firm/firm?firm=${id}&type='details'`)
    },
    async getLocationTree(data) {
      this.locationTree = []
      this.advancedLocations = []
      this.locations = []
      // NOTE: this is currently not being used
      this.loading.locationTree = true
      this.locationTree = await api.get(`firm/locationTree?firm=${data.firm}&showInactive=${data.showInactive}&forWhat=${data.for}`)
      this.loading.locationTree = false
      // this.locations = this.flattenTree(this.locationTree)
      console.log('Got Location Tree', {
        tree: this.locationTree,
        locations: this.locations
      })
      return this.locationTree
    },
    async saveNewLocation() {
      return await api.post('firm/createFirm', this.addLocation)
    },
    async saveLocation() {
      return await api.post('firm/saveFirm', this.location)
    },
    async deleteLocation(data) {
      return await api.post('firm/deleteFirms', data)
    },
    async getChildren(firm) {
      this.children = []
      this.loading.children = true
      this.children = await api.get(`firm/childFirms?firm=${firm}`)
      this.loading.children = false
      console.log('Got Children', this.children)
      return this.children
    },
    async searchFirmUser(search) {
      this.loading.users = true
      this.foundFirmUsers = await api.get('firm/searchFirmUser', search)
      this.loading.users = false
      return this.foundFirmUsers
    },
    async searchLocations(options) {
      this.loading.findingLocations = true
      this.foundLocations = await api.get(
        `firm/searchFirms?search=${options.search}&type=${options.type}&firm=${options.firm}&firmType=${options.firmType}`
      )
      this.loading.findingLocations = false
      return this.foundLocations
    },
    async searchAdvanced(options) {
      this.loading.advancedLocations = true
      this.advancedLocations = await api.get('firm/searchFirms', options)
      this.loading.advancedLocations = false
      return this.advancedLocations
    },
    async pushLocation(data) {
      await api.post('data/pushLocationTree', data)
    },
    async moveLocation(data) {
      return await api.post('firm/moveFirm', data)
    },
    async getLog(data) {
      this.loading.log = true
      this.log = await api.get('data/log', data)
      this.loading.log = false
      console.log('Got Log', this.log)
      return this.log
    },
    exportLocations(firm) {
      console.log('Export Locations', firm)
    },
    exportUsers(firm) {
      console.log('Export Users', firm)
    },
    async getNewMemberCount(data) {
      this.newMemberCount = 0
      let results = await api.get('member/members', data)
      if (results) {
        this.newMemberCount = results.newMemberCount
      }
      console.log('Got New Member Count', this.newMemberCount)
    },
    async getMembers(data) {
      let now = new Date()
      now.setHours(0, 0, 0, 0) // Set to start of the day
      this.isAnyMemberChecked = false
      this.loading.members = true
      this.members = await api.get('member/members', data)
      this.loading.members = false
      if (this.members) {
        if (this.members.items) {
          if (this.members.items.length > 0) {
            this.members.items.forEach((element) => {
              element.checked = false
              element.parentName = ''
              element.isNew = false
              let found = this.locations.find((x) => parseInt(x.id) === parseInt(element.parent))
              if (found) {
                element.parentName = found.name
              }
              if (element.optInOn) {
                let evalDate = new Date(element.optInOn)
                if (evalDate >= now) {
                  element.isNew = true
                }
              }
            })
          }
        }
      }
      console.log('Got Members', this.members)
      return this.members
    },
    async getMember(data) {
      this.member = await api.get(`member/member?parent=${data.parent}&firm=${data.firm}&source=${data.source}`)
      if (this.member) {
        if (this.member.contact) {
          this.member.contact = JSON.parse(this.member.contact)
        }
        if (this.member.address) {
          this.member.address = JSON.parse(this.member.address)
        }
        if (this.member.email) {
          this.member.email = JSON.parse(this.member.email)
        }
        if (this.member.phone) {
          this.member.phone = JSON.parse(this.member.phone)
        }
      }
      console.log('Got Member', this.member)
      return this.member
    },
    async saveMemberParent(data) {
      return await api.post('member/saveMemberParent', data)
    },
    async saveNewMember(data) {
      return await api.post('member/saveMember', data)
    },
    async removeMembers(data) {
      console.log('Removing Members', data)
      return await api.post('member/removeMembers', data)
    },
    async getMembersForExport(data) {
      this.membersForExport = []
      this.membersForExport = await api.get('member/members', data)
      console.log('Got Members for Export', this.membersForExport)
      return this.membersForExport
    },
    async getInsurers(firm) {
      this.insurers = []
      this.loading.insurers = true
      this.insurers = await api.get(`firm/getFirmInsurance?firm=${firm}&type=all`)
      this.loading.insurers = false
      return this.insurers
    },
    async searchMembers(data) {
      this.foundMembers = await api.get(`member/search?firm=${data.firm}&search=${data.search}&lookup=${data.lookup}`)
      console.log('Got Found Members', this.foundMembers)
      return this.foundMembers
    },
    async getCalibrationPricing(data) {
      this.calibrationPricing = []
      console.log('Getting Calibration Pricing', data)
      this.calibrationPricing = await api.get('adasmatrix/getCalibrationPricing', data)
      console.log('Got Calibration Pricing', this.calibrationPricing)
      return this.calibrationPricing
    },
    async saveCalibrationPricing(data) {
      return await api.post('adasmatrix/saveCalibrationPricing', data)
    },
    // rejects with the server's message on failure
    async uploadCalibrationPricing(data) {
      return await api.post('adasmatrix/uploadCalibrationPricing', data)
    },
    async importCalibrationPricing(data) {
      return await api.post('adasmatrix/importCalibrationPricing', data)
    },
    async exportCalibrationPricing(firm) {
      return await api.get(`adasmatrix/exportCalibrationPricing?firm=${firm}`)
    },
    async getPreferences(data) {
      this.preferences = []
      let response = await api.get('firm/preferences', data)
      if (response) {
        if (response !== '') {
          if (Array.isArray(response)) {
            response.forEach((element) => {
              element.changed = false
              let found = false
              for (var i = 0; i < this.preferences.length; i++) {
                if (this.preferences[i].name === element.name && this.preferences[i].type === element.type) {
                  found = true
                  this.preferences[i].value = element.value
                  break
                }
              }
              if (!found) {
                this.preferences.push(element)
              }
            })
          } else {
            this.preferences.push(response)
          }
        }
      }
      console.log('Got Preferences', this.preferences)
      return this.preferences
    },
    setPreference(data) {
      let found = this.preferences.find((x) => x.name === data.name && x.type === data.type)
      if (found) {
        found.changed = true
        found.firm = data.firm
        if (data.isInactive) {
          found.isInactive = data.isInactive
        }
        found.value = data.value
        console.log('Updated Preference', found)
      } else {
        data.changed = true
        this.preferences.push(data)
        console.log('Added to Preferences', data)
      }
    },
    updatePreference(data) {
      let found = false
      if (this.preferences.length > 0) {
        for (let i = 0; i < this.preferences.length; i++) {
          if (this.preferences[i].type === data.type && parseInt(this.preferences[i].firm) === parseInt(data.firm)) {
            if (this.preferences[i].name === data.name) {
              if (data.isInactive !== undefined && data.isInactive !== null) {
                this.preferences[i].isInactive = data.isInactive
              } else {
                this.preferences[i].value = data.value
              }
              this.preferences[i].changed = true
              found = true
              break
            }
          }
        }
      }
      if (found === false) {
        data.changed = true
        this.preferences.push(data)
      }
    },
    async savePreferences() {
      if (this.preferences) {
        const savePromises = []
        this.preferences.forEach((element) => {
          if (element.changed) {
            let data = {
              firm: element.firm,
              firmPreferenceName: element.name,
              preference: element.value.toString(),
              firmPreferenceCategory: element.type,
              isInactive: element.isInactive ? 1 : 0
            }
            console.log('Saving preference:', data)
            savePromises.push(api.post('firm/savePreference', data))
          }
        })
        
        // Wait for all save operations to complete
        if (savePromises.length > 0) {
          await Promise.all(savePromises)
          console.log(`Saved ${savePromises.length} preferences`)
        }
        
        // Mark all preferences as unchanged
        if (this.preferences.length > 0) {
          for (let i = 0; i < this.preferences.length; i++) {
            this.preferences[i].changed = false
          }
        }
      }
    },
    async searchShops(data) {
      this.foundShops = []
      this.loading.searchShops = true
      let results = await api.get('firm/searchForShops', data)
      if (results) {
        if (results.some((obj) => obj.hasOwnProperty('searchPostalCode'))) {
          let cnt = 0
          let temp = []
          console.log('Got Shops 1', results)
          results.forEach((element) => {
            if (cnt === 0) {
              temp = JSON.parse(element.locations)
            } else {
              temp = temp.concat(JSON.parse(element.locations))
            }
            cnt++
          })
          this.foundShops = temp.filter((value, index, self) => index === self.findIndex((t) => t.firm === value.firm))
          this.foundShops.sort((a, b) => (a.firmName > b.firmName ? 1 : -1))
        } else {
          console.log('Got Shops 2', results)
          this.foundShops = results
        }
      }
      this.loading.searchShops = false
      return this.foundShops
    },
    async getFirmInsurance(data) {
      if (data.type === 'firm') {
        this.loading.firmInsurance = true
        this.firmInsurance = []
        this.firmInsurance = await api.get(`firm/getFirmInsurance?firm=${data.firm}`)
        if (this.firmInsurance) {
          this.firmInsurance.forEach((element) => {
            element.isRemove = false
          })
        } else {
          this.firmInsurance = []
        }
        this.loading.firmInsurance = false
        console.log('Got Firm Insurance', this.firmInsurance)
        return this.firmInsurance
      } else if (data.type === 'available') {
        this.loading.availableInsurance = true
        this.availableInsurance = []
        this.availableInsurance = await api.get(`firm/getFirmInsurance?firm=${data.firm}&type=available`)
        this.loading.availableInsurance = false
        console.log('Got Available Insurance', this.availableInsurance)
        return this.availableInsurance
      } else if (data.type === 'all') {
        this.loading.availableInsurance = true
        this.availableInsurance = []
        this.availableInsurance = await api.get(`firm/getFirmInsurance?firm=${data.firm}&type=all`)
        this.loading.availableInsurance = false
        console.log('Got All Insurance', this.availableInsurance)
        return this.availableInsurance
      }
    },
    async saveFirmInsurance(data) {
      return await api.post('firm/saveFirmInsurance', data)
    },
    async deleteFirmInsurance(firmFirm) {
      return await api.get(`firm/deleteFirmInsurance?firmFirm=${firmFirm}`)
    },

    // Profile-related functions
    async getServiceMethodOptions() {
      this.loading.serviceMethodOptions = true
      try {
        const response = await api.get('lookup/serviceMethodOptions')
        if (response) {
          this.serviceMethodOptions = response
        }
      } catch (error) {
        console.error('Error loading service method options:', error)
        this.serviceMethodOptions = []
      } finally {
        this.loading.serviceMethodOptions = false
      }
    },

    async getServiceListOptions() {
      this.loading.serviceListOptions = true
      try {
        const response = await api.get('lookup/serviceListOptions')
        if (response) {
          this.serviceListOptions = response
        }
      } catch (error) {
        console.error('Error loading service list options:', error)
        this.serviceListOptions = []
      } finally {
        this.loading.serviceListOptions = false
      }
    },

    async getTrainingCertificationOptions() {
      this.loading.trainingCertificationOptions = true
      try {
        const response = await api.get('lookup/trainingCertificationOptions')
        if (response) {
          this.trainingCertificationOptions = response
        }
      } catch (error) {
        console.error('Error loading training certification options:', error)
        this.trainingCertificationOptions = []
      } finally {
        this.loading.trainingCertificationOptions = false
      }
    },

    async getAvailableInsurers() {
      this.loading.availableInsurers = true
      try {
        const response = await api.get('firm/getLaunchpadFirms?getType=insurer&firm=1')
        if (response) {
          this.availableInsurers = response
          console.log('Loaded available insurers:', this.availableInsurers)
        }
      } catch (error) {
        console.error('Error loading available insurers:', error)
        this.availableInsurers = []
      } finally {
        this.loading.availableInsurers = false
      }
    },

    // Get profile data using Launchpad preferences system
    async getProfileData(firmId) {
      this.loading.profileData = true
      try {
        // Get preferences from Launchpad instead of local database
        const response = await api.get('firm/getLaunchpadPreferences', {
          firm: firmId,
          category: 'profile',
          name: 'profileData'
        })

        let profileDataPref = null
        if (response && Array.isArray(response)) {
          profileDataPref = response.find(pref => pref.type === 'profile' && pref.name === 'profileData')
        } else if (response && response.type === 'profile') {
          profileDataPref = response
        }

        if (profileDataPref && profileDataPref.value) {
          try {
            // Parse the JSON profile data
            const savedProfileData = JSON.parse(profileDataPref.value)
            console.log('Raw saved profile data from Launchpad:', savedProfileData)
            console.log('businessPhotos in saved data:', savedProfileData.businessPhotos)

            // Merge with defaults to ensure all fields exist
            this.profileData = { ...this.getDefaultProfileData(), ...savedProfileData }
            console.log('Loaded profile data from Launchpad:', this.profileData)
            console.log('Final businessPhotos:', this.profileData.businessPhotos)
          } catch (e) {
            console.warn('Error parsing saved profile data:', e)
            this.profileData = this.getDefaultProfileData()
          }
        } else {
          // No saved profile data, use defaults
          this.profileData = this.getDefaultProfileData()
          console.log('No saved profile data found in Launchpad, using defaults')
        }

      } catch (error) {
        console.error('Error loading profile data from Launchpad:', error)
        this.profileData = this.getDefaultProfileData()
      } finally {
        this.loading.profileData = false
      }
    },

    // Update a specific field in the profile data
    updateProfileField(field, value, firmId) {
      if (this.profileData) {
        this.profileData[field] = value
        console.log(`Updated profile field ${field}:`, value)
        
        // Mark that we have unsaved changes - we'll save the entire profileData as JSON
        // when saveProfileData is called
      }
    },

    // Save profile data to Launchpad
    async saveProfileData(firmId) {
      console.log('saveProfileData called with firmId:', firmId)
      this.loading.savingProfile = true
      try {
        // Include postal codes from Serving tab in profile data
        const profileDataWithPostalCodes = {
          ...this.profileData,
          postalCodesServiced: this.postalCodes.join(', ')
        }

        // Save all profile data as a single JSON preference to Launchpad
        const profileDataJson = JSON.stringify(profileDataWithPostalCodes)
        console.log('Saving profile data to Launchpad:', profileDataWithPostalCodes)
        console.log('businessPhotos being saved:', profileDataWithPostalCodes.businessPhotos)
        console.log('postalCodesServiced being saved:', profileDataWithPostalCodes.postalCodesServiced)
        console.log('Profile data JSON being saved:', profileDataJson)

        const data = {
          firm: firmId,
          firmPreferenceName: 'profileData',
          preference: profileDataJson,
          firmPreferenceCategory: 'profile',
          isInactive: 0
        }

        console.log('Saving profile data to Launchpad:', data)
        await api.post('firm/saveLaunchpadPreference', data)
        console.log('Profile data saved successfully to Launchpad')

        return { success: true }
      } catch (error) {
        console.error('Error saving profile data:', error)
        return { success: false, error: error.message }
      } finally {
        this.loading.savingProfile = false
      }
    },

    // Helper method to get default profile data structure
    getDefaultProfileData() {
      return {
        companyOverview: '',
        daysOfService: [],
        hoursOfOperation: '',
        openTime: '',
        closeTime: '',
        businessLicenseNumbers: '',
        postalCodesServiced: '',
        trainedTechnicians: 0,
        mobileVehicles: 0,
        calibrationCenters: 0,
        warranty: '',
        net30Terms: false,
        hasOtherPaymentOptions: false,
        customPaymentOptions: '',
        serviceMethods: [],
        serviceList: [],
        trainingCertificates: [],
        customServiceMethod: null,
        businessPhotos: [],
        certificationImages: {},
        supportedInsurers: []
      }
    },

    // Clear all profile data
    clearProfileData() {
      this.profileData = this.getDefaultProfileData()
      this.serviceMethodOptions = []
      this.serviceListOptions = []
      this.trainingCertificationOptions = []
    },
    async searchPartners(options) {
      this.loading.findingLocations = true
      this.foundLocations = await api.get(
        `firm/searchPartners?search=${options.search}&type=${options.type}&firm=${options.firm}`
      )
      this.loading.findingLocations = false
      return this.foundLocations
    },
    async saveFirmPartner(data) {
      return await api.post('firm/saveFirmPartner', data)
    },
    async getFirmPartners(id) {
      this.loading.firmPartners = true
      this.firmPartners = []
      this.firmPartners = await api.get(`firm/getFirmPartners?firm=${id}`)
      this.loading.firmPartners = false
      return this.firmPartners
    },
    async deleteFirmPartner(firmFirm) {
      return await api.get(`firm/deleteFirmPartner?firmFirm=${firmFirm}`)
    },
    async getFirmReviews(firmId, offset = null, pageSize = null) {
      try {
        const params = { firm: firmId }
        if (offset !== null && pageSize !== null) {
          params.offset = offset
          params.pageSize = pageSize
        }
        let response = await api.get('firm/getFirmReviews', params)
        console.log('Got Firm Reviews - Raw Response:', response)
        console.log('Response type:', typeof response)

        // If response is a string, parse it first
        if (typeof response === 'string') {
          try {
            response = JSON.parse(response)
            console.log('Parsed response:', response)
          } catch (e) {
            console.error('Error parsing response string:', e)
            return []
          }
        }

        // Now check if it has the paginated structure
        if (response && typeof response === 'object' && 'JsonResult' in response && 'TotalCount' in response) {
          // Paginated response
          let items = response.JsonResult
          console.log('JsonResult type:', typeof items)

          if (typeof items === 'string') {
            try {
              items = JSON.parse(items)
              console.log('Parsed JsonResult:', items)
            } catch (e) {
              console.error('Error parsing JsonResult:', e)
              items = []
            }
          }

          // Ensure items is an array
          if (!Array.isArray(items)) {
            console.warn('Items is not an array, converting:', items)
            items = items ? [items] : []
          }

          return {
            items: items,
            totalCount: response.TotalCount || 0
          }
        }

        // Non-paginated response (backward compatibility)
        // This could also have JsonResult as the top-level property
        if (response && typeof response === 'object' && 'JsonResult' in response) {
          let items = response.JsonResult
          if (typeof items === 'string') {
            try {
              items = JSON.parse(items)
            } catch (e) {
              console.error('Error parsing JsonResult:', e)
              items = []
            }
          }

          // Ensure items is an array
          if (!Array.isArray(items)) {
            items = items ? [items] : []
          }

          return items
        }

        // Direct array response
        if (Array.isArray(response)) {
          return response
        }

        return []
      } catch (error) {
        console.error('Error getting firm reviews:', error)
        return []
      }
    }
  }
})
